'use client';

import { c as _c } from "react/compiler-runtime";
import { Smartphone, UserCheck } from 'lucide-react';
import Button from '../common/Button';
import Modal, { ModalContent, ModalFooter, ModalHeader } from '../HOC/Modal';
type Props = {
  closeHandler: () => void;
};
export const BotExplanationModal = t0 => {
  const $ = _c(11);
  const {
    closeHandler
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-2"><UserCheck className="text-primary" /><h2 className="text-xl font-semibold">Bot Account</h2></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== closeHandler) {
    t2 = <ModalHeader closeHandler={closeHandler}>{t1}</ModalHeader>;
    $[1] = closeHandler;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="text-base text-textSecondary">This account has been flagged by our automated system as a bot. It will identify as a bot until they verify through mobile app biometrics.</p>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ModalContent><div className="space-y-6 py-2">{t3}<div className="space-y-4"><div className="flex items-start gap-3"><Smartphone className="mt-1 text-primary" size={20} /><div><h3 className="font-semibold">Biometric Verification</h3><p className="text-sm text-textSecondary">Remove the bot status by completing biometric verification through the mobile app. This ensures you're a real person and unlocks full platform features.</p></div></div></div></div></ModalContent>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== closeHandler) {
    t5 = <ModalFooter><Button text="Got it" variant="PRIMARY" onClick={closeHandler} /></ModalFooter>;
    $[5] = closeHandler;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== closeHandler || $[8] !== t2 || $[9] !== t5) {
    t6 = <Modal closeHandler={closeHandler}>{t2}{t4}{t5}</Modal>;
    $[7] = closeHandler;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};